/**
 * index.js
 *
 * @Author: wangyinan
 * @Date: 2017/7/17 上午10:26
 */
import DropdownMenu from './DropdownMenu';

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/dropdownMenu/index.js